import withStyles from '@mui/styles/withStyles';

function TabBarContent({ children = null, classes = {} }) {
  return <div className={classes.content}>{children}</div>;
}

export const styles = () => ({
  content: {
    position: 'relative',
    zIndex: 1,
  },
});

export default withStyles(styles)(TabBarContent);
